import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Channel } from '@pixacare/chat';

@Pipe({
  name: 'channelSubtitle',
  standalone: true,
})
export class ChannelSubtitlePipe implements PipeTransform {
  private authenticationService = inject(AuthenticationService);
  private translocoService = inject(TranslocoService);

  transform(channel: Channel): unknown {
    if (!channel.lastMessage) {
      return '';
    }

    const isLastMessageSenderCurrentUser = this.isCurrentUser(channel.lastMessage.senderId);

    if (channel.lastMessage.special?.shares) {
      return this.formatShareMessage(isLastMessageSenderCurrentUser);
    }

    if (channel.lastMessage.special?.telemonitoringId) {
      return channel.lastMessage.text;
    }

    if (channel.lastMessage.text) {
      return this.formatTextMessage(channel, isLastMessageSenderCurrentUser);
    }

    return '';
  }

  private isCurrentUser(senderId: number): boolean {
    return senderId === this.authenticationService.user.id;
  }

  private formatTextMessage(channel: Channel, isLastMessageSenderCurrentUser: boolean): string {
    if (channel.users.length < 3) {
      return channel.lastMessage.text;
    }

    const lastMessageSenderName = isLastMessageSenderCurrentUser
      ? this.translocoService.translate('Vous')
      : channel.lastMessage.senderName;
    return `${lastMessageSenderName}: ${channel.lastMessage.text}`;
  }

  private formatShareMessage(isLastMessageSenderCurrentUser: boolean): string {
    return isLastMessageSenderCurrentUser
      ? this.translocoService.translate('Vous avez partagé une séquence')
      : this.translocoService.translate('Vous avez reçu une séquence');
  }
}
